import Http from "./Http";

export class TwoFactorsService extends Http {
  /**
   * Complete 2FA auth
   * @param {Object} body
   * @param {string} body.token
   */
  complete2FA(body) {
    return this.post("/two-factors", body);
  }

  /**
   * Verify enable two-factor authentication
   * @param {Object} body
   * @param {string} body.base32
   * @param {string} body.token
   */
  verifyEnable2FA(body) {
    return this.post("/two-factors/verify", body);
  }

  /**
   * Enable/disable two-factor authentication, get QR-code and base32 for enabling
   * @param {Object} body
   * @param {boolean} body.isEnabled
   */
  toggle2FA(body) {
    return this.patch("/two-factors/is-enabled", body);
  }
}

export default new TwoFactorsService();
